import 'COMMON';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import 'Bem/site/popup-subscribe/popup-subscribe';

svgSpriteLoader('/site/digest/svg/sprite.svg?v=20180320');